import { nextTick } from "vue"
import { createI18n } from "vue-i18n"
import enMessages from "./locales/en.json" // Import English messages directly

export const SUPPORT_LOCALES = ["en", "ar"]

export function setupI18n(options = { locale: "en" }) {
  const initialMessages = {}
  if (options.locale === "en") {
    initialMessages.en = enMessages
  }

  const i18n = createI18n({
    ...options,
    messages: initialMessages, // Provide pre-loaded 'en' messages
    legacy: options.mode === "legacy", // createI18n expects 'legacy' boolean, not 'mode' string
    fallbackLocale: options.fallbackLocale || 'en'
  })

  // If the initial locale's messages weren't pre-loaded (e.g., not 'en'), load them.
  // Or if 'en' was preloaded, setI18nLanguage will handle setting HTML attributes.
  setI18nLanguage(i18n, options.locale)
  return i18n
}

export async function setI18nLanguage(i18n, locale) {
  // Only load if messages for the locale are not already set
  if (!i18n.global.availableLocales.includes(locale) || !i18n.global.getLocaleMessage(locale) || Object.keys(i18n.global.getLocaleMessage(locale)).length === 0) {
    await loadLocaleMessages(i18n, locale)
  }
  if (i18n.mode === "legacy") {
    i18n.global.locale = locale
  } else {
    i18n.global.locale.value = locale
  }
  document.querySelector("html").setAttribute("lang", locale)
  document.querySelector("html").setAttribute("dir", "ar" == locale ? "rtl" : "ltr")
}

export async function loadLocaleMessages(i18n, locale) {
  locale = locale.replace(" ", "")
  // load locale messages with dynamic import
  const messages = await import(`./locales/${locale}.json`)

  // set locale and locale message
  i18n.global.setLocaleMessage(locale, messages.default)

  return nextTick()
}
